import { FC, useState, FormEvent } from "react";
import styles from "./AskAiDrawer.module.scss";

export interface AskAiDrawerProps {
  isOpen: boolean;
  onClose: () => void;
  contextLabel?: string;
}

export const AskAiDrawer: FC<AskAiDrawerProps> = ({
  isOpen,
  onClose,
  contextLabel = "DESIGN CRITERIA / MECHANICAL",
}) => {
  const [question, setQuestion] = useState("");

  if (!isOpen) return null;

  const handleSubmit = (e: FormEvent) => {
    e.preventDefault();
  };

  const handleSuggestionClick = (text: string) => {
    setQuestion(text);
  };

  return (
    <>
      <div className={styles.backdrop} onClick={onClose} aria-hidden="true" />
      <aside className={styles.drawer} aria-label="Ask AI assistant">
        <div className={styles.header}>
          <div className={styles.titleGroup}>
            <span className={styles.sparkleIcon} aria-hidden="true">
              ✦
            </span>
            <h2 className={styles.title}>Ask AI</h2>
          </div>
          <button
            type="button"
            className={styles.closeButton}
            onClick={onClose}
            aria-label="Close Ask AI"
          >
            ×
          </button>
        </div>

        <div className={styles.content}>
          <div className={styles.demoNotice}>
            <span className={styles.demoIcon} aria-hidden="true">
              ⚠️
            </span>
            <div>
              <div className={styles.demoTitle}>Demo Concept</div>
              <p className={styles.demoText}>
                This AI assistant is a design prototype and not implemented in
                this demo.
              </p>
            </div>
          </div>

          <div className={styles.contextLabel}>{contextLabel}</div>

          <form className={styles.form} onSubmit={handleSubmit}>
            <div className={styles.inputWrapper}>
              <textarea
                className={styles.textarea}
                placeholder="Ask your question about this context..."
                value={question}
                onChange={(e) => setQuestion(e.target.value)}
                rows={3}
                aria-label="Ask your question about this context"
              />
              <button type="submit" className={styles.sendButton}>
                Send →
              </button>
            </div>
          </form>

          <div className={styles.suggestionsSection}>
            <button
              type="button"
              className={styles.suggestionChip}
              onClick={() =>
                handleSuggestionClick("What are the ductwork specifications?")
              }
            >
              What are the ductwork specifications?
            </button>
            <button
              type="button"
              className={styles.suggestionChip}
              onClick={() =>
                handleSuggestionClick("Summarize post-fitout information.")
              }
            >
              Summarize post-fitout information.
            </button>
            <button
              type="button"
              className={styles.suggestionChip}
              onClick={() =>
                handleSuggestionClick("When was the last mechanical update?")
              }
            >
              When was the last mechanical update?
            </button>
            <button
              type="button"
              className={styles.suggestionChip}
              onClick={() =>
                handleSuggestionClick("Compare Engie DVD records.")
              }
            >
              Compare Engie DVD records.
            </button>
          </div>
        </div>
      </aside>
    </>
  );
};
